import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import Reveal from "./Reveal";
import { useLang } from "@/i18n/LangContext";

const TXT = {
  es: { overline: "Destacado · Ya disponible", cta: "Conseguir en Amazon", intrigue: "Intriga · Escena de la novela" },
  en: { overline: "Featured · Available now", cta: "Get it on Amazon", intrigue: "Intrigue · A scene from the novel" },
  pt: { overline: "Destaque · Já disponível", cta: "Adquirir na Amazon", intrigue: "Intriga · Cena do romance" },
  fr: { overline: "À la une · Disponible", cta: "Disponible sur Amazon", intrigue: "Intrigue · Scène du roman" },
};

const PromoBanner = () => {
  const { lang } = useLang();
  const T = TXT[lang] ?? TXT.es;

  return (
    <section data-testid="promo-banner" className="relative py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 spotlight-glow" aria-hidden="true" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 space-y-20">
        <Reveal>
          <p className="text-center font-code text-[11px] tracking-[0.35em] uppercase text-[#C5A059] mb-8">
            {T.overline}
          </p>
          <motion.a
            href="https://a.co/d/00OGkJAH"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="promo-banner-link"
            whileHover={{ scale: 1.015 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="group relative block max-w-3xl mx-auto border border-[#D4AF37]/25 shadow-[0_40px_100px_rgba(0,0,0,0.6)] overflow-hidden"
          >
            <img
              src="/promo-toda-la-verdad.jpg"
              alt="Toda la Verdad — Nada más que la verdad · Confesiones del guardaespaldas de Chávez · Disponible en Amazon"
              className="w-full h-auto block"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0E]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2.5 px-6 py-3 bg-[#D4AF37] text-[#0D0D0E] text-xs tracking-[0.18em] uppercase font-semibold opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500 whitespace-nowrap">
              {T.cta}
              <ExternalLink className="w-3.5 h-3.5" />
            </span>
          </motion.a>
        </Reveal>

        <Reveal>
          <p className="text-center font-code text-[11px] tracking-[0.35em] uppercase text-[#C5A059] mb-8">
            {T.intrigue}
          </p>
          <motion.a
            href="https://a.co/d/01oEWH9d"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="promo-estambul-link"
            whileHover={{ scale: 1.015 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="group relative block max-w-3xl mx-auto border border-[#D4AF37]/25 shadow-[0_40px_100px_rgba(0,0,0,0.6)] overflow-hidden"
          >
            <img
              src="/promo-estambul.jpg"
              alt="Toda la Verdad: 3 de Enero — El otro encuentro de Estambul · Estambul, septiembre de 2018 · Libro físico disponible en Amazon"
              className="w-full h-auto block"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0E]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2.5 px-6 py-3 bg-[#D4AF37] text-[#0D0D0E] text-xs tracking-[0.18em] uppercase font-semibold opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500 whitespace-nowrap">
              {T.cta}
              <ExternalLink className="w-3.5 h-3.5" />
            </span>
          </motion.a>
        </Reveal>
      </div>
    </section>
  );
};

export default PromoBanner;
